import SearchParams from '@/utils/search/SearchParams'
import HeadMeta from '@/utils/head/HeadMeta'
import HeadLink from '@/utils/head/HeadLink'
import { useMainStore } from '@/store'

export const useHeadParams = context => {
  const app = useNuxtApp()
  const store = useMainStore()
  const router = useRouter()
  const apiSearchParams = new SearchParams(store, context.$route).apiSearchParams
  context = { ...context, ...app }
  context.$store = store
  context.$router = router
  if (context.isEventListPage && context.$route.path === '/') return {}
  const headMeta = new HeadMeta(context, apiSearchParams)
  const headLink = new HeadLink(context, apiSearchParams)
  const metas = []

  metas.push({ name: 'reverse', content: true })
  if (headMeta.description) metas.push({ name: 'description', content: headMeta.description })
  if (headMeta.keywords) metas.push({ name: 'keywords', content: headMeta.keywords })
  if (headMeta.viewport) metas.push({ name: 'viewport', content: headMeta.viewport })
  if (headMeta.robots) {
    if (!store.isLoggedIn) store.dispatch('postNoIndexPage', { full_path: context.$route.fullPath }).then(res => {})
    metas.push({ name: 'robots', content: headMeta.robots })
  }
  if (headMeta.ogp) {
    metas.push({ name: 'card', property: 'twitter:card', content: headMeta.ogp['twitter:card'] })
    metas.push({ name: 'site', property: 'twitter:site', content: headMeta.ogp['twitter:site'] })
    metas.push({ name: ':title', property: 'twitter:title', content: headMeta.ogp['twitter:title'] })
    metas.push({ name: 'description', property: 'twitter:description', content: headMeta.ogp['twitter:description'] })
    metas.push({ name: 'image', property: 'twitter:image', content: headMeta.ogp['twitter:image'] })
    metas.push({ name: 'type', property: 'og:type', content: headMeta.ogp['og:type'] })
    metas.push({ name: 'title', property: 'og:title', content: headMeta.ogp['og:title'] })
    metas.push({ name: 'url', property: 'og:url', content: headMeta.ogp['og:url'] })
    metas.push({ name: 'image', property: 'og:image', content: headMeta.ogp['og:image'] })
  }

  const headConfig = {
    htmlAttrs: { lang: app.$i18n.locale },
    title: headMeta.title,
    titleTemplate: headMeta.titleTemplate,
    meta: metas,
    link: headLink.links
  }

  // トップの場合のみOrganization構造化データを追加(https://github.com/linkbal/mj-issues/issues/227)
  if (context.$route.path === '/') {
    headConfig.script = [
      {
        type: 'application/ld+json',
        innerHTML: JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '街コンジャパン',
          legalName: '株式会社リンクバル',
          url: 'https://machicon.jp/',
          logo: 'https://machicon.jp/favicon.ico',
          foundingDate: '2011-12-09',
          sameAs: ['https://www.instagram.com/machiconjapan/'],
          address: {
            '@type': 'PostalAddress',
            streetAddress: '明石町7-14 築地リバーフロント6F',
            addressLocality: '中央区',
            addressRegion: '東京都',
            postalCode: '104-0044',
            addressCountry: 'JP'
          },
          numberOfEmployees: {
            '@type': 'QuantitativeValue',
            minValue: 50,
            maxValue: 100
          },
          description:
            '街コンジャパンは、日本最大級の街コン・パーティー情報の総合ポータルサイトです。東京、大阪、名古屋をはじめ日本全国のイベント情報の検索から参加申し込みまで、あなたの出会いを全力でサポートします。2015年4月にマザーズに上場した株式会社リンクバル（現：東証グロース）が運営しているため、安心してイベントにご参加いただけます。街コン、恋活・婚活パーティー、趣味コンはもちろん、合コン形式の少人数イベントまで、あなたにピッタリのイベントが、いつでも簡単に探せます'
        })
      }
    ]
  }

  useHead(headConfig)
}

export const useNoIndex = () => {
  useHead({ meta: { name: 'robots', content: 'noindex,follow' } })
}
